import { BaseApi } from "../BaseApi";

let API: BaseApi | null = null;

function getApiInstance(): BaseApi {
  if (!API) {
    API = new BaseApi();
  }
  return API;
}

function buildUrl(
  baseUrl: string,
  params?: { [key: string]: string | number | undefined }
) {
  const queryParams = new URLSearchParams();
  if (params) {
    Object.keys(params).forEach((key) => {
      const val = params[key];
      if (val !== undefined && val !== null && val !== "") {
        queryParams.append(key, String(val));
      }
    });
  }
  const query = queryParams.toString();
  return query ? `${baseUrl}?${query}` : baseUrl;
}

function getProducts(params: {
  limit: number;
  skip: number;
  keyword?: string;
  owner?: string;
  country?: string;
  mode?: string;
  startDate?: string;
  endDate?: string;
}) {
  const baseUrl = "products";
  const url = buildUrl(baseUrl, params);

  try {
    return getApiInstance().get(url);
  } catch (error) {
    console.error("Error fetching products:", error);
  }
}

function createProductApi(params: {
  country: string;
  affiliate: string;
  name: string;
  price: number;
  description: string;
  quantity: number;
  comment: string;
  productImage: string;
}) {
  const baseUrl = "products";
  const url = buildUrl(baseUrl);

  try {
    return getApiInstance().post(url, params);
  } catch (error) {
    console.error("Error creating product:", error);
  }
}

function deleteProductApi(params: { ids: string[] }) {
  const baseUrl = "products";
  const url = `${baseUrl}/delete`;
  try {
    return getApiInstance().put(url, params);
  } catch (error) {
    console.error("Error Deletting user:", error);
  }
}

function updateProductApi(params: {
  id: string;
  name: string;
  price: number;
  description: string;
  quantity: number;
  comment: string;
  productImage: string;
}) {
  const baseUrl = "products";
  const url = `${baseUrl}/${params.id}`;
  try {
    return getApiInstance().put(url, params);
  } catch (error) {
    console.error("Error updating product:", error);
  }
}

function getProduct(params: { id: string }) {
  const baseUrl = "products";
  const url = `${baseUrl}/${params.id}`;
  try {
    return getApiInstance().get(url);
  } catch (error) {
    console.error("Error fetching product:", error);
  }
}

function bulkImportProductsApi(payload: { rows: any[]; dryRun?: boolean }) {
  return getApiInstance().post("products/bulk-import", payload);
}

export type ProductHistorySource = "all" | "log" | "stock";

export type ProductHistoryItem = {
  _id: string;
  source: "LOG" | "STOCK";
  createdAt: string;
  user?: { _id?: string; name?: string; role?: string } | null;
  // LOG fields
  action?: "CREATE" | "UPDATE" | "DELETE" | "STATUS_CHANGE" | "BULK_OPERATION";
  oldData?: any;
  newData?: any;
  metadata?: any;
  description?: string;
  // STOCK fields
  movementType?: string;
  deltaRest?: number;
  deltaMissing?: number;
  restAfter?: number;
  missingAfter?: number;
  order?: { _id: string; orderId?: string } | null;
  shipping?: { _id: string } | null;
  note?: string;
};

function getProductHistory(params: {
  id: string;
  skip?: number;
  limit?: number;
  source?: ProductHistorySource;
  userId?: string;
  startDate?: string;
  endDate?: string;
}) {
  const { id, ...rest } = params;
  const url = buildUrl(`products/${id}/history`, {
    skip: rest.skip ?? 0,
    limit: rest.limit ?? 20,
    source: rest.source,
    userId: rest.userId,
    startDate: rest.startDate,
    endDate: rest.endDate,
  });
  return getApiInstance().get(url);
}

export {
  getProducts,
  createProductApi,
  getProduct,
  updateProductApi,
  deleteProductApi,
  bulkImportProductsApi,
  getProductHistory,
};
